<div #playerContainer class="ghost-player-wrapper"></div>
